import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSeatedTickets } from '../../../selectors/reserved-seating';
import { getSelectedEvent } from '../../../selectors/event';
import WithCurrencyConfig from '../../../config/WithCurrencyConfig';
import { getJSFormattedCurrency } from '@h/currency';
import Translation from '@s/Translation';
import { TICKET_FEE_SEPARATE } from '../../../reducers/ui';
import { getFeeDisplayOption } from '../../../selectors/ui';

class SeatingChartTicketPickerTotals extends Component {

    getFormattedTotal = amount => {
        let total = 0;
        this.props.tickets.forEach(ticket => {
            if (ticket.event_id != this.props.selectedEvent.event.event_id) {
                return;
            }

            if (ticket?.cost?.amount) {
                total += +ticket.cost.amount;
            }

            if (ticket?.buyer_fee?.amount) {
                total += +ticket.buyer_fee.amount;
            }
            if (this.props.discloseFee) {
                total += +ticket?.per_ticket_fee?.amount;
            }
        });
        return this.props.currencyConfig ? getJSFormattedCurrency(total, this.props.currencyConfig) : '';
    }

    getCurrentEventCount = () => {
        return this.props.tickets.filter(t => t.event_id == this.props.selectedEvent.event.event_id).length;
    }

    render() {
        if (!this.props.tickets.length) {
            return null;
        }

        return (
            <div className="seating-chart__picker-totals">
                <Translation interpolation={{
                    seats: this.getCurrentEventCount(),
                    amount: this.getFormattedTotal()
                    }}>{this.getCurrentEventCount() == 1 ? 'checkout__seat_total_cost' : 'checkout__seats_total_cost'}</Translation>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        discloseFee: getFeeDisplayOption(state) == TICKET_FEE_SEPARATE,
        tickets: getSeatedTickets(state),
        selectedEvent: getSelectedEvent(state),
    };
};

export default connect(mapStateToProps)(WithCurrencyConfig(SeatingChartTicketPickerTotals))

